import styled from "styled-components";

export const Alert = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  height: 100vh;
  overflow: hidden;
  z-index: 9999;
  background: ${(props) => props.theme.fadedBackground};
`;

export const AlertContainer = styled.div`
  position: relative;
  color: ${(props) => props.theme.white};
  max-width: 50rem;
  width: 100%;
  margin: 0 2.4rem;
  padding: 2.4rem 1.2rem 1.2rem;
  background-color: ${(props) => props.theme.alertBackground};
`;

export const AlertContainerInner = styled.div`
  flex-direction: column;
  justify-content: center;

  h4 {
    margin: 0 0 2.4rem;
  }

  .label-container {
    margin-bottom: 0.6rem;
  }

  label {
    font-size: 1.2rem;
  }

  img {
    position: absolute;
    top: 1.2rem;
    right: 1.2rem;
  }

  input {
    width: 100%;
    margin-bottom: 0.6rem;
  }

  p {
    font-size: 1.4rem;
  }
`;

export const AlertButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2.4rem;

  button {
    width: 100%;

    &:nth-child(2) {
      margin-left: 1.6rem;
    }
  }
`;

export const Button = styled.button`
  font-size: 1.2rem;
  color: ${(props) => props.theme.defaultButtonText};
  background-color: ${(props) => props.theme.white};
  border: none;
  border-radius: 0.8rem;
  padding: 1.6rem;
  cursor: pointer;
  font-weight: bold;
`;
